module.exports = __webpack_public_path__ + "static/media/BO.e4e6219b.svg";